/* eslint-disable max-classes-per-file */
// eslint-disable-next-line import/no-extraneous-dependencies
import "reflect-metadata"

import CirculationPlaceItem from "@infra/models/CirculationPlace"
import {
  ChannelProductUrlResponse,
  CustomerResponse,
  ModelDetailPlate,
  Quote,
  RequestResponse,
  VehicleGroup
} from "@infra/models/PlateInfo"

export class TransactionStatecontextBase {
  requestOk: boolean | null = null

  vehicleInfoOk: boolean | null = null

  circulationPlaceOk: boolean | null = null

  vehicleGroupOk: boolean | null = null

  customerOk: boolean | null = null

  channelOk: boolean | null = null

  quoteOk: boolean | null = null

  requestResponse: RequestResponse = new RequestResponse()

  consultaVehiculoResponse: ModelDetailPlate | null = null

  circulationPlaceResponseList: Array<CirculationPlaceItem> = []

  vehicleGroupResponse: VehicleGroup | null = null

  fullCustomerResponse: CustomerResponse = new CustomerResponse()

  channelProductUrlResponse: ChannelProductUrlResponse | null = null

  quoteResponse: Quote = new Quote()

  origen: string = ""

  flujo: string = ""

  derivacion?: number

  circulationPlaceResponse: string = ""

  confirmationOk?: boolean = false

  queryString?: string = ""
}
